module.exports = __webpack_public_path__ + "media/src/website/images/locations/oberschleissheim/02-6dc542276ffc24dd7e3a5e1962f9c313.jpg";